import React from 'react';
import { useTranslation } from 'react-i18next';

const processSteps = [
  { id: 'collect', number: '01' },
  { id: 'treat', number: '02' },
  { id: 'reuse', number: '03' },
];

function About() {
  const { t } = useTranslation();

  return (
    <section className="process-section" id="About" aria-labelledby="process-title">
      <div className="section-container">
        <header className="section-heading process-heading">
          <p className="section-eyebrow">{t('about.eyebrow')}</p>
          <h2 id="process-title">{t('about.title')}</h2>
          <p>{t('about.introduction')}</p>
        </header>

        <ol className="process-steps">
          {processSteps.map((step) => (
            <li className="process-step" key={step.id}>
              <span className="process-step__number" aria-hidden="true">{step.number}</span>
              <h3>{t(`about.steps.${step.id}.title`)}</h3>
              <p>{t(`about.steps.${step.id}.description`)}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}

export default About;
